var _defs, _rect, _text, _text2, _rect2, _circle, _text3, _text4, _text5, _text6, _text7, _text8, _line, _text9, _text10, _text11, _rect3, _circle2, _text12, _text13, _text14, _text15, _text16, _text17, _line2, _text18, _text19, _text20, _rect4, _circle3, _text21, _text22, _text23, _text24, _text25, _text26, _line3, _text27, _text28, _text29, _rect5, _circle4, _text30, _text31, _text32, _text33, _text34, _text35, _line4, _text36, _text37, _text38, _line5, _line6, _line7, _text39, _line8, _line9, _line10, _line11, _line12, _circle5, _circle6, _circle7, _circle8, _text40, _text41, _text42, _text43, _text44;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase6Fig2OneRuleFourLayers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 600",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 1 L 8 5 L 0 9 Z",
    fill: "#6B7F74"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 600,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The em dash rule at four points of enforcement")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Ordered by when each one runs, from authoring time to the assembly harness.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 110,
    width: 255,
    height: 250,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 142,
    r: 13,
    fill: "#1A2F2A"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 146.5,
    fontSize: 12,
    fontWeight: 700,
    fill: "#FFFDF7",
    textAnchor: "middle"
  }, "1")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 146,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "AUTHORING TIME")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 186,
    fontSize: 15.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Memory plus skill rule")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 210,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "The rule loads with project")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 227,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "memory and the writing skill,")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 244,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "live while copy is drafted.")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 262,
    x2: 287,
    y2: 262,
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 284,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "FIRST DEFENSE")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 304,
    fontSize: 12.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "Steers the text as it is")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 321,
    fontSize: 12.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "written, at the keyboard.")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 331,
    y: 110,
    width: 255,
    height: 250,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 357,
    cy: 142,
    r: 13,
    fill: "#1A2F2A"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 357,
    y: 146.5,
    fontSize: 12,
    fontWeight: 700,
    fill: "#FFFDF7",
    textAnchor: "middle"
  }, "2")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 379,
    y: 146,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "REQUIRED CI GATE")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 347,
    y: 186,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "voice_lint")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 347,
    y: 205,
    fontSize: 15.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "on catalog copy")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 347,
    y: 228,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "Runs inside the required CI")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 347,
    y: 245,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "gate on every catalog change.")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 347,
    y1: 262,
    x2: 570,
    y2: 262,
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 347,
    y: 284,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "CATCHES WHAT 1 MISSES")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 347,
    y: 304,
    fontSize: 12.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "Blocks a merge carrying one")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 347,
    y: 321,
    fontSize: 12.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "into shipped catalog copy.")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 110,
    width: 255,
    height: 250,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 142,
    r: 13,
    fill: "#1A2F2A"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 146.5,
    fontSize: 12,
    fontWeight: 700,
    fill: "#FFFDF7",
    textAnchor: "middle"
  }, "3")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 662,
    y: 146,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "POST-AUTHOR")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 186,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "Stop hook")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 205,
    fontSize: 15.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "on changed files")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 228,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "Fires once, after the")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 245,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "authoring session ends.")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 630,
    y1: 262,
    x2: 853,
    y2: 262,
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 284,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "CATCHES WHAT 2 MISSES")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 304,
    fontSize: 12.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "Catches files authored")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 321,
    fontSize: 12.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "outside the catalog path.")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 897,
    y: 110,
    width: 255,
    height: 250,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 923,
    cy: 142,
    r: 13,
    fill: "#1A2F2A"
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 923,
    y: 146.5,
    fontSize: 12,
    fontWeight: 700,
    fill: "#FFFDF7",
    textAnchor: "middle"
  }, "4")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 945,
    y: 146,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "SUPPLY INTEGRATION")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 913,
    y: 186,
    fontSize: 15.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Assembler scrub")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 913,
    y: 210,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "The last pass inside the")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 913,
    y: 227,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "supply integration harness,")), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 913,
    y: 244,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "before copy ships.")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 913,
    y1: 262,
    x2: 1136,
    y2: 262,
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 913,
    y: 284,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "CATCHES WHAT 3 MISSES")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 913,
    y: 304,
    fontSize: 12.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "Scrubs copy assembled")), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 913,
    y: 321,
    fontSize: 12.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "from mined supply sources.")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 308,
    y1: 235,
    x2: 324,
    y2: 235,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 591,
    y1: 235,
    x2: 607,
    y2: 235,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 874,
    y1: 235,
    x2: 890,
    y2: 235,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 414,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "WHEN EACH ONE RUNS")), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 440,
    x2: 1140,
    y2: 440,
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 175.5,
    y1: 366,
    x2: 175.5,
    y2: 432,
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 458.5,
    y1: 366,
    x2: 458.5,
    y2: 432,
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 741.5,
    y1: 366,
    x2: 741.5,
    y2: 432,
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 1024.5,
    y1: 366,
    x2: 1024.5,
    y2: 432,
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 440,
    r: 5,
    fill: "#1A2F2A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.5,
    cy: 440,
    r: 5,
    fill: "#1A2F2A"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 741.5,
    cy: 440,
    r: 5,
    fill: "#1A2F2A"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1024.5,
    cy: 440,
    r: 5,
    fill: "#1A2F2A"
  })), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 175.5,
    y: 466,
    fontSize: 11.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "while drafting")), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 458.5,
    y: 466,
    fontSize: 11.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "at merge")), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 741.5,
    y: 466,
    fontSize: 11.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "after authoring")), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 1024.5,
    y: 466,
    fontSize: 11.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "at assembly")), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 552,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "Four chances to stop a dash before ship, each one placed where the layer before it loses sight of the text.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase6Fig2OneRuleFourLayers);
export default __webpack_public_path__ + "static/media/case6-fig2-one-rule-four-layers.9b8e046d71df573fc9c78f21a3dd5f1a.svg";
export { ForwardRef as ReactComponent };